// extracted by mini-css-extract-plugin
module.exports = {"noticeMFA":"styles_noticeMFA__UGC9k"};